module.exports = __webpack_public_path__ + "static/img/icon_success.d4e6172b.png";